import { mergeProps, type ParentComponent } from "solid-js";
import { Checkbox as ArkCheckbox } from "@ark-ui/solid";
import Text from "../text/Text";
import { isBoolean } from "lodash-es";
import { CheckboxIndicator } from "../checkbox/Checkbox.tsx";

type CheckboxListItemProps = {
  label: string;
  checked: boolean;
  disabled?: boolean;
  setChecked: (value: boolean) => void;
};

const CheckboxListItem: ParentComponent<CheckboxListItemProps> = (rawProps) => {
  const props = mergeProps({ disabled: false }, rawProps);

  return (
    <ArkCheckbox.Root
      checked={props.checked}
      disabled={props.disabled}
      onCheckedChange={(e) => {
        if (isBoolean(e.checked)) {
          props.setChecked(e.checked);
        }
      }}
      class="relative flex w-full justify-between gap-2 px-3 py-2.5"
      classList={{
        "bg-surface-active-brand": props.checked,
        "bg-surface-disabled": !props.checked && props.disabled,
        "cursor-pointer text-primary hover:bg-surface-hover": !props.disabled,
        "text-disabled": props.disabled,
      }}
    >
      <div class="flex min-w-0 shrink gap-2.5">
        <CheckboxIndicator />
        <ArkCheckbox.Label asChild={() => <Text class="shrink text-base-regular" text={props.label} truncate />} />
      </div>
      <ArkCheckbox.HiddenInput />
    </ArkCheckbox.Root>
  );
};

export default CheckboxListItem;
